import React from 'react';
import { FieldRadioButton } from '../../components';
import { HorseImage } from './HorseImage';
import css from './SwitchHorse.css';

export const HorseRadio = ({ listing, form }) => (
    <FieldRadioButton
        form={form}
        id={listing.id.uuid}
        value={listing.id.uuid}
        name="mainHorseId"
        label={
            <div className={css.label}>
                <HorseImage listing={listing} />
                {listing.attributes.title}
            </div>
        }
    />
);
